import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchParams } from '../searchParams';

@JsonObject('CaseSessionSearchParams')
export class CaseSessionSearchParams extends SearchParams {
    @JsonProperty('created_date_range_after', String, true)
    createdDateAfter = null;

    @JsonProperty('created_date_range_before', String, true)
    createdDateBefore = null;

    @JsonProperty('session_date_range_after', String, true)
    sessionDateAfter = null;

    @JsonProperty('session_date_range_before', String, true)
    sessionDateBefore = null;

    @JsonProperty('note', [Number], true)
    note = [];

    @JsonProperty('court', [Number], true)
    court = [];

    @JsonProperty('circle', [Number], true)
    circle = [];

    @JsonProperty('lawyers', [Number], true)
    lawyers = [];

    @JsonProperty('clients', [Number], true)
    clients = [];

    @JsonProperty('opponents', [Number], true)
    opponents = [];

    @JsonProperty('case__sequence', Number, true)
    fileSeq = undefined;

    @JsonProperty('case__case_number', Number, true)
    fileNum = undefined;
}